/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetDashboardV2Query } from '../../models/get-dashboard-v-2-query';
import { GetDashboardV2QueryResult } from '../../models/get-dashboard-v-2-query-result';

export interface ApiDashboardGetDashboardV2Post$Plain$Params {
      body?: GetDashboardV2Query
}

export function apiDashboardGetDashboardV2Post$Plain(http: HttpClient, rootUrl: string, params?: ApiDashboardGetDashboardV2Post$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDashboardV2QueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiDashboardGetDashboardV2Post$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetDashboardV2QueryResult>;
    })
  );
}

apiDashboardGetDashboardV2Post$Plain.PATH = '/api/Dashboard/GetDashboardV2';
